import type { StarRating } from 'src/components/type';
import hirerGraphqlClient from './client';
import { mutation } from './schema/mutationUpdateApplicationRating';
import type {
  UpdateApplicationRatingMutation,
  UpdateApplicationRatingMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';

export interface UpdateApplicationRatingResponse {
  rating: StarRating;
}

export const updateApplicationRating = async (
  prospectId: string,
  rating: StarRating,
): Promise<UpdateApplicationRatingResponse> => {
  await hirerGraphqlClient.mutate<
    UpdateApplicationRatingMutation,
    UpdateApplicationRatingMutationVariables
  >({
    variables: { prospectId, rating },
    mutation,
  });

  return {
    rating,
  };
};
